import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

declare var $: any;

@Component({
  selector: 'ngx-modal-recebiveis-cerc',
  templateUrl: './modal-recebiveis-cerc.component.html',
  styleUrls: ['./modal-recebiveis-cerc.component.scss']
})
export class ModalRecebiveisCercComponent implements OnInit {
  
  @ViewChild("card", null)

  private card: ElementRef;
  public isRecebiveisCerc = false;
  public customLogin = null;
  
  constructor(
    protected ref: NbDialogRef<ModalRecebiveisCercComponent>,
    private cdRef: ChangeDetectorRef,
    private router: Router,
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.cdRef.detectChanges();
    const el = this.card && this.card.nativeElement;
    if (el && el.ownerDocument && el.ownerDocument.activeElement && el.ownerDocument.activeElement.blur) {
      el.ownerDocument.activeElement.blur();
    }
    this.isRecebiveisCerc = true;

  }

  continuar() {
    this.ref.close(true);
    this.router.navigate(['/pages/compra-online/termo-condicao']);
  }

  voltar() {
    this.ref.close(false);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
